import ProjectStagesConfig from './ProjectStagesConfig'

export default ProjectStagesConfig
